import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../shapes/Line'
import IconText from '../../packages/kiti/components/presentation/IconText'
import Menu, { MenuItem } from './Menu'
import Popover from '../helpers/Popover'
import Scroll from '../helpers/Scroll'

const InternalMenuItem = ({ onChange, onClick, toggle, value, label, line, ...props }) => {
  if (line) return <HorizontalLine thin lineColor={COLORS.light3} />

  const handleSelect = (v, toggle) => () => {
    onClick && onClick(v)
    onChange && onChange(v)
    toggle()
  }

  return (
    <MenuItem key={value} onClick={handleSelect(value, toggle)} {...props}>
      {label || value}
    </MenuItem>
  )
}

const DropdownLink = ({ color, options, onChange, label, size, actionContent, t, bold, ...props }) => {
  actionContent = actionContent || (
    <IconText color={color} label={label} iconRight="RiArrowDownSFill" size={size} iconSize={1.2} bold={bold} />
  )

  const render = ({ toggle }) => (
    <Menu>
      <Scroll>
        {options.map(option => (
          <InternalMenuItem key={option.value} onChange={onChange} toggle={toggle} t={t} {...option} />
        ))}
      </Scroll>
    </Menu>
  )

  return <Popover actionContent={actionContent} render={render} noPadding {...props} />
}

export default DropdownLink
